import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/shop/reviews";

export const reviews = {
    // ...example,
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
